import React from 'react'
import { Route, Redirect } from '@fs/zion-router'
import { useAppProvider } from '../providers/AppProvider'

const SimpleAuthRoute = ({ children, ...rest }) => {
  const { signedIn, userLoading } = useAppProvider()

  if (userLoading) {
    return null
  }

  if (!signedIn) {
    return <Redirect to="/opportunities" />
  }

  return <Route {...rest} render={(routeProps) => children(routeProps)} />
}

export default SimpleAuthRoute
